import { getLanguageRegionCodeFromLocale } from '@alltrails/core/utils/languageTypeModifiers';
import type { Locale } from '@alltrails/types/Locale';

export const OsanoLanguageMap = {
  ['en-US']: 'en',
  ['en-GB']: 'en-gb',
  ['da-DK']: 'da',
  ['de-DE']: 'de',
  ['es-ES']: 'es',
  ['es-MX']: 'es-mx',
  ['fr-FR']: 'fr',
  ['it-IT']: 'it',
  ['nl-NL']: 'nl',
  ['nb-NO']: 'nb',
  ['pl-PL']: 'pl',
  ['pt-PT']: 'pt',
  ['pt-BR']: 'pt-br',
  ['sv-SE']: 'sv'
};

export const getOsanoLocale = (locale: Locale) => {
  const languageRegionCode = getLanguageRegionCodeFromLocale(locale);
  return OsanoLanguageMap[languageRegionCode] || 'en-gb';
};

export const getOsanoSrc = (locale: Locale) => {
  const osanoLocale = getOsanoLocale(locale);

  return `https://cmp.osano.com/${process.env.NEXT_PUBLIC_OSANO_USER_ID}/${process.env.NEXT_PUBLIC_OSANO_CONFIG_ID}/osano.js?language=${osanoLocale}`;
};

export const OSANO_UI_TARGET_ID = 'osano-cmp-slot';
